import React, { useState } from 'react';
import Tree from '../../Tree';
import { jsx as ___EmotionJSX } from "@emotion/react";
function ObjectField({
  label,
  description,
  fields
}) {
  const [expanded, setExpanded] = useState(true);
  const [treeType, setTreeType] = useState(null);
  return ___EmotionJSX(Tree, {
    single: true,
    onExpandToggle: () => setExpanded(!expanded),
    expanded: expanded,
    label: label,
    description: description,
    type: treeType,
    onHeaderMouseEnter: () => setTreeType('primary'),
    onHeaderMouseLeave: () => setTreeType(null)
  }, fields);
}
export default ObjectField;